import React, { useState, useEffect } from "react";
import {
  TextField,
  RadioGroup,
  Radio,
  Checkbox,
  Select,
  FormControl,
  Box,
  Chip,
  Typography,
  MenuItem,
  InputAdornment,
  Link,
  Autocomplete,
  IconButton,
  Tooltip
} from "@mui/material";
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircleOutline';
import styles from "./formField.module.css";
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller } from 'react-hook-form';
import dayjs from "dayjs";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

const FormField = ({ field, register, errors, onLinkButtonClick, selectedValues, setSelectedValues, control, watch, form, handleDeleteField }) => {
  const [selectedRadioValue, setSelectedRadioValue] = useState("");
  const [selectedNumberValue, setSelectedNumberValue] = useState(null);
  const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  const [areaOfSpecialityArray, setAreaOfSpecialityArray] = useState([]);
  const [removedValues, setRemovedValues] = useState({});
  const [insuranceFields, setInsuranceFields] = useState([""]);
  useEffect(() => {
    if (!selectedValues) return;
    setSelectedSpecialties(Object.keys(selectedValues));
  }, [selectedValues]);

  const handleChange = (event) => {
    setSelectedRadioValue(event.target.value);
  };

  const handleRemove = (category, value, event) => {
    event.stopPropagation();

    setSelectedValues((prev) => ({
      ...prev,
      [category]: prev[category]?.filter((v) => v !== value) || [],
    }));

    setRemovedValues((prev) => ({
      ...prev,
      [category]: [...(prev[category] || []), value],
    }));
  };

  const handleReAdd = (category, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [category]: [...(prev[category] || []), value],
    }));
    setRemovedValues((prev) => ({
      ...prev,
      [category]: prev[category]?.filter((v) => v !== value) || [],
    }));
  };


  const handleNumberInputChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = inputValue.match(/^\d*\.?\d{0,2}$/) ? inputValue : selectedNumberValue;
    setSelectedNumberValue(formattedValue);
  };

  const setAdditionlServices = (key, options) => {
    setSelectedSpecialties((prevSelected) => {
      const isSelected = prevSelected.includes(key);
      const updatedSelected = isSelected
        ? prevSelected.filter((item) => item !== key)
        : [...prevSelected, key];
      setSelectedValues((prevValues) => {
        const updatedValues = { ...prevValues };
        if (isSelected) {
          delete updatedValues[key];
        } else {
          updatedValues[key] = Array.from(new Set([...(updatedValues[key] || []), ...options]));
        }
        return updatedValues;
      });
      setAreaOfSpecialityArray(updatedSelected);
      return updatedSelected;
    });
  };

  const renderInput = () => {
    switch (field.type) {
      case "text":
        return (
          <Box className={styles.inputWrapper} >
            <Controller
              name={field.id}
              control={control}
              defaultValue={null}
              render={({ field: controllerField }) => (
                <TextField
                  {...controllerField}
                  label={field.placeholder}
                  required={field.required}
                  style={{ width: field?.width ?? "100%" }}
                  sx={{ mb: 2 }}
                  error={!!errors[field.id]}
                  // helperText={errors[field.id]?.message}
                  helperText={
                    errors[field.id]?.message ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                        <Typography variant="caption" color="error">
                          {errors[field.id]?.message}
                        </Typography>
                      </Box>
                    ) : null
                  }
                />
              )}
            />
          </Box>
        );
      case "textAdd":
        const handleAddField = () => {
          setInsuranceFields((prev) => [...prev, ""]);
        };

        const handleRemoveField = (index) => {
          setInsuranceFields((prev) => prev.filter((_, i) => i !== index));
        };

        return (
          <Box>
            {insuranceFields.map((_, index) => (
              <Box key={index} sx={{ width: '100%' }}>
                <Controller
                  key={index}
                  name={`${field.id}[${index}]`}
                  control={control}
                  defaultValue=""
                  render={({ field: controllerField }) => (
                    <TextField
                      {...controllerField}
                      label={field.placeholder}
                      required={field.required}
                      placeholder={field.placeholder}
                      fullWidth
                      error={!!errors?.[field.id]?.[index]}
                      // helperText={errors?.[field.id]?.[index]?.message}
                      helperText={
                        errors?.[field.id]?.[index]?.message ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                            <Typography variant="caption" color="error">
                              {errors?.[field.id]?.[index]?.message}
                            </Typography>
                          </Box>
                        ) : null
                      }
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" sx={{ alignItems: 'flex-start' }}>
                            {index === 0 ? (
                              <IconButton
                                edge="end"
                                onClick={handleAddField}
                                sx={{
                                  backgroundColor: '#008388',
                                  color: '#fff',
                                  borderRadius: '8px',
                                  marginRight: "-10px",
                                  '&:hover': { backgroundColor: '#006f73' },
                                  width: 36,
                                  height: 36,
                                }}
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            ) : (
                              <IconButton
                                edge="end"
                                onClick={() => handleRemoveField(index)}
                                sx={{
                                  backgroundColor: '#f44336',
                                  color: '#fff',
                                  borderRadius: '8px',
                                  marginRight: "-10px",
                                  '&:hover': { backgroundColor: '#d32f2f' },
                                  width: 36,
                                  height: 36,
                                }}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Box>
            ))}
          </Box>
        );
      case "radio":
        return (
          <Controller
            name={field.id}
            control={control}
            defaultValue=""
            render={({ field: controllerField }) => (
              <>
                <Box className={styles.inputWrapper} style={{ width: field?.width || "100%" }}>
                  <RadioGroup
                    row
                    value={controllerField.value}
                    onChange={controllerField.onChange}
                    className={styles.radioGroup}
                  >
                    {field.options.map((option, index) => (
                      <Box key={index} className={styles.radioOptionBox}>
                        <Typography className={styles.radioOptionLabel}>{option}</Typography>
                        <Radio
                          className={styles.radioButton}
                          value={option}
                          required={field.required}
                        // You don't need register here because Controller handles it
                        />
                      </Box>
                    ))}
                  </RadioGroup>
                </Box>
                {errors[field.id] && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                    <Typography variant="caption" color="error">
                      {errors[field.id]?.message}
                    </Typography>
                  </Box>
                )}
              </>
            )}
          />
        );

      case "checkbox":
        return (
          <Box className={styles.checkboxContainer} style={{ flexDirection: !field.width ? "column" : "" }}>
            {field.id === 'areaOfSpeciality' && errors[field.id] && areaOfSpecialityArray.length === 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                <Typography variant="caption" color="error">
                  At least one speciality is required
                </Typography>
              </Box>
            )}
            {field.options && Object.entries(field.options).map(([key, value], index) => (
              <>
                <Box
                  key={index}
                  style={{ width: field.width ?? "100%" }}
                  className={`${styles.checkboxItem} ${index === Object.keys(field.options).length - 1 ? styles.checkboxItemLast : ""}`}
                >
                  <Box className={styles.checkboxItemHeading}>
                    <span className={styles.checkboxLabel}>{key}</span>
                    <Checkbox
                      className={styles.checkbox}
                      checked={selectedSpecialties.includes(key)}
                      {...register(field.id)}
                      onChange={() => field.id !== 'areaOfSpeciality' ? onLinkButtonClick({ key, value }) : setAdditionlServices(key, value.options)}
                    />
                  </Box>
                  {selectedSpecialties?.includes(key) && value.options?.length > 0 && (
                    <Box className={styles.multiSelectContainer}>
                      <Box>
                        <Typography variant="subtitle1" color="textSecondary" className="margin-top-20">
                          {value.introText}
                        </Typography>

                      </Box>
                      <FormControl fullWidth>
                        <Select
                          multiple
                          value={selectedValues[key] || []}
                          error={!!errors[field.id]}
                          // helperText={errors[field.id]?.message}
                          helperText={
                            errors[field.id]?.message ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                                <Typography variant="caption" color="error">
                                  {errors[field.id]?.message}
                                </Typography>
                              </Box>
                            ) : null
                          }
                          onChange={(event) => {
                            const value = event.target.value;
                            setSelectedValues((prev) => ({
                              ...prev,
                              [key]: value,
                            }));
                          }}
                          sx={{
                            height: '100% !important',
                            '& .MuiOutlinedInput-notchedOutline': {
                              border: 'none !important'
                            },
                            '& .MuiSelect-icon': {
                              display: 'none !important' // Hide the dropdown arrow
                            }
                          }}
                          renderValue={(selected) => {
                            const selectedSet = new Set(selected);
                            const removedSet = new Set(removedValues[key] || []);
                            const fullOptions = value.options || [];

                            return (
                              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                {selected.map((val) => (
                                  <Chip
                                    key={val}
                                    label={val}
                                    onDelete={(event) => handleRemove(key, val, event)}
                                    className={styles.chip}
                                    onMouseDown={(event) => event.stopPropagation()}
                                    classes={{ deleteIcon: styles.deleteIcon }}
                                  />
                                ))}

                                {fullOptions
                                  .filter(opt => !selectedSet.has(opt) && !removedSet.has(opt))
                                  .map((val) => (
                                    <Chip
                                      key={val}
                                      label={val}
                                      className={styles.removedChip}
                                      onClick={() => handleReAdd(key, val)}
                                      onMouseDown={(event) => event.stopPropagation()}
                                      icon={<AddCircleIcon className={styles.addIcon} />}
                                    />
                                  ))}

                                {(removedValues[key] || []).map((val) => (
                                  <Chip
                                    key={val}
                                    label={val}
                                    className={styles.removedChip}
                                    onClick={() => handleReAdd(key, val)}
                                    onMouseDown={(event) => event.stopPropagation()}
                                    icon={<AddCircleIcon className={styles.addIcon} />}
                                  />
                                ))}
                              </Box>
                            );
                          }}
                        >

                          {value.options.map((option) => (
                            <MenuItem key={option} value={option}>
                              <Checkbox
                                checked={selectedValues[key]?.includes(option) || false}
                                className={styles.checkbox}
                              />
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </>
            ))}
          </Box>
        );
      case "small-checkbox":
        return (
          <>
            <Box className={styles.checkboxContainer} style={{ flexDirection: !field.width ? "column" : "" }}>
              {field.options.map((option, index) => {
                  const selectedCheckboxValues = form?.watch?.(field.id) || [];
                  const isChecked = selectedCheckboxValues?.includes(option?.value || option);
                  return (
                      <Box
                          key={index}
                          style={{ width: field.width ?? "100%" }}
                          className={`${styles.smallCheckboxItem} ${index === field.options.length - 1 ? styles.checkboxItemLast : ""
                          }`}
                      >
                          <span className={styles.checkboxLabel}>{option}</span>
                          <Checkbox className={styles.checkbox} value={option}
                                    {...register(field.id)}
                                    error={!!errors[field.id]}
                                    // helperText={errors[field.id]?.message}
                                    helperText={
                                      errors[field.id]?.message ? (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                          <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                                          <Typography variant="caption" color="error">
                                            {errors[field.id]?.message}
                                          </Typography>
                                        </Box>
                                      ) : null
                                    }
                                    checked={isChecked}
                          />
                      </Box>
                  )})}

            </Box>
            {errors[field.id] && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                <Typography variant="caption" color="error">At least one checkbox must be selected</Typography>
              </Box>
            )}
          </>
        );
      case "no-border-checkbox":
        return (
          <>
            <Controller
              name={field.id}
              control={control}
              defaultValue={[]}
              render={({ field: controllerField }) => (
                <Box className={styles.noBorderCheckboxContainer} style={{ flexDirection: !field.width ? "column" : "" }}>
                  {field.options.map((option, index) => {
                    const isChecked = controllerField.value?.includes(option.value);
                    return (
                      <Box key={index} className={styles.noCheckboxItem}>
                        <Checkbox
                          className={styles.checkbox}
                          checked={isChecked}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...(controllerField.value || []), option.value]
                              : (controllerField.value || []).filter(v => v !== option.value);
                            controllerField.onChange(newValue);
                          }}
                        />
                        <Typography variant="gothamRegular" className={styles.noBorderCheckboxLabel}>
                          {option.label}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              )}
            />
            {errors[field.id] && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                <Typography variant="caption" color="error">
                  At least one checkbox must be selected
                </Typography>
              </Box>
            )}
          </>
        );
      case "checkbox-image":
        // Watch for changes to the checkbox field
        const selectedCheckboxValues = watch(field.id) || [];

        return (
          <>
            <Box className={styles.checkboxImageContainer}>
              {field.options.map((option, index) => {
                const [key, value] = Object.entries(option)[0];
                const image = require(`../../../app/assets/${value}`);

                // safely get selected values
                const selectedCheckboxValues = form?.watch?.(field.id) || [];

                return (
                  <Box key={index} className={styles.checkboxImageItem}>
                    <Box className={styles.checkboxImageBox}>
                      <Checkbox
                        className={styles.checkbox}
                        value={key}
                        {...register(field.id)}
                        checked={selectedCheckboxValues.includes(key)}
                        onChange={(e) => {
                          const newValues = e.target.checked
                            ? [...selectedCheckboxValues, key]
                            : selectedCheckboxValues.filter((val) => val !== key);

                          form.setValue(field.id, newValues);
                        }}
                      />
                    </Box>
                    {image && (
                      <img
                        src={image}
                        alt={key}
                        className={styles.checkboxImage}
                      />
                    )}
                    <span className={styles.checkboxImageLabel}>{key}</span>
                  </Box>
                );
              })}
            </Box>
            {errors[field.id] && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                <Typography variant="caption" color="error">
                  At least one checkbox must be selected
                </Typography>
              </Box>
            )}
          </>
        );

      case "dropdown":
        return (
          <Box className={styles.inputWrapper}>
            <Controller
              name={field.id}
              control={control}
              defaultValue={field.defaultValue || ""}
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  value={value || null}
                  onChange={(event, newValue) => {
                    onChange(newValue);
                    if(!newValue && handleDeleteField){
                      handleDeleteField()
                    }
                  }}
                  options={field.options || []}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onChange={(e) => onLinkButtonClick(e.target.value)}
                      placeholder={field.placeholder || "Select an option"}
                      required={field.required}
                      error={!!errors[field.id]}
                      // helperText={errors[field.id]?.message}
                      helperText={
                        errors[field.id]?.message ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                            <Typography variant="caption" color="error">
                              {errors[field.id]?.message}
                            </Typography>
                          </Box>
                        ) : null
                      }
                    />
                  )}
                  className={styles.dropdown}
                  noOptionsText="Search for Town/City"
                />
              )}
            />
          </Box>
        );
      case "time":
        return (
          <>
            <Box className={styles.inputWrapper}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name={field.id}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TimePicker
                      label={field.label}
                      value={value ? dayjs(value, "HH:mm") : null}
                      onChange={(newValue) => {
                        const formattedTime = newValue ? newValue.format("HH:mm") : "";
                        onChange(formattedTime);
                      }}
                      required={field.required}
                      className={styles.timePicker}
                      error={!!errors[field.id]}
                      // helperText={errors[field.id]?.message}
                      helperText={
                        errors[field.id]?.message ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                            <Typography variant="caption" color="error">
                              {errors[field.id]?.message}
                            </Typography>
                          </Box>
                        ) : null
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select a time" variant="outlined" />
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
            {errors[field.id] && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                <Typography variant="caption" color="error">{errors[field.id]?.message}</Typography>
              </Box>
            )}
          </>
        );
      case "link-button":
        return (
          <Box className={styles.inputWrapper}>
            <Link
              component="button"
              className={styles.linkButton}
              onClick={(e) => {
                e.preventDefault();
                onLinkButtonClick && onLinkButtonClick(field);
              }}
            >
              {field.linkTitle}
              {
                field.infoMessage && (
                  <Tooltip title={field.infoMessage}>
                    <InfoOutlineIcon className={styles.infoIcon} />
                  </Tooltip>
                )
              }
            </Link>
          </Box>
        );
      case "number-unit":
        return (
          <>
            <Box className={styles.inputWrapper} style={{ width: field?.width || "100%" }}>
              <TextField
                type="text"
                inputMode="decimal"
                placeholder={field.placeholder}
                required={field.required}
                className={styles.numberUnitInput}
                value={selectedNumberValue || null}
                {...register(field.id, {
                  setValueAs: (v) => (v === "" ? null : v), // empty string → null
                })}
                sx={{
                  '& .MuiInputBase-root': {
                    borderRadius: '8px',
                    padding: '0px',
                  },
                  '& .MuiInputBase-input': {
                    height: '48px',
                  },
                  '& .MuiInputAdornment-root': {
                    padding: '10px',
                    height: '90%',
                    marginTop: '4px !important',
                    fontWeight: '500 !important',
                    borderBottomLeftRadius: '8px !important',
                    borderTopLeftRadius: '8px !important',
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className={styles.unit}>
                      <Box className={`${field.unit === '£' ? styles.unitCircle : ''}`}>{field.unit}</Box>
                    </InputAdornment>
                  ),
                }}
                fullWidth
                onChange={handleNumberInputChange}
              />
            </Box>
            {errors[field.id] && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                <Typography variant="caption" color="error">
                  {errors[field.id]?.message || "Input must be a positive number"}
                </Typography>
              </Box>
            )}
          </>
        );
      case "textarea":
        return (
          <Box className={`${styles.inputWrapper} ${styles.textAreaBox}`} style={{ width: field?.width || "100%" }}>
            <TextField
              label={field.label}
              multiline
              rows={field.rows}
              {...register(field.id)}
              error={!!errors[field.id]}
              // helperText={errors[field.id]?.message}
              helperText={
                errors[field.id]?.message ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <ErrorOutlineRoundedIcon fontSize="small" color="error" />
                    <Typography variant="caption" color="error">
                      {errors[field.id]?.message}
                    </Typography>
                  </Box>
                ) : null
              }
              fullWidth
              required={field.required}
              placeholder={field.placeholder || "Enter your text here"}
              sx={{
                '& .MuiInputBase-root': {
                  height: '100% !important',
                }
              }}
            />
            <Box className={styles.textAreaInfo}>
              <InfoOutlineIcon />
              <Typography variant="gothamRegular">To boost your SEO ranking, please provide a unique description of your clinic that is different to the description of your clinic on your website</Typography>
            </Box>
          </Box>
        );
      case "file":
        return (
          <Box className={`${styles.inputWrapper} ${styles.textAreaBox}`}>
            {field.src ? (
              <Box className={styles.imagePreview} onClick={() => onLinkButtonClick(field)}>
                <img
                  src={field.src}
                  alt="Uploaded"
                  style={{ width: "263px", height: "263px", objectFit: "cover", borderRadius: "8px" }}
                />
              </Box>
            ) : (
              <Box className={styles.imageContainer} onClick={() => onLinkButtonClick(field)}>
                <InsertPhotoOutlinedIcon sx={{ fontSize: 50, color: "#686868" }} />
                <Typography variant="gothamRegular" className="margin-top-15 f-500">
                  Click to upload clinic's logo
                </Typography>
              </Box>
            )}
            <Box className={styles.fileInfo}>
              <InfoOutlineIcon />
              <Typography variant="gothamRegular">Uploading your logo will help your patients recognise your clinic and will help to differentiate your clinic from the competition, resulting in a higher number of bookings. </Typography>
            </Box>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {renderInput()}
    </div>
  );
};

export default FormField;
